<script lang="ts">
  import { formatNumber, getStr, globalCurrencyTag } from '../../../common/util';
  export let price = null;
  export let cssClass = '';
</script>

{#if price}
  <span class={cssClass}>
    {@html getStr('jood.price.with.currency', [globalCurrencyTag, formatNumber(price)])}
  </span>
{/if}
